import { minute, hour, year, month, day } from "../../../fable_modules/fable-library-js.4.19.0/Date.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { errorMsg, spinner, icon } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import * as react from "react";
import { Msg } from "./Types.fs.js";
import { map, defaultArg } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { asString } from "../../../../Bfs.Web.Data.Service.Contracts/Shared.fs.js";
import { length, collect, find, isEmpty, ofArray, map as map_1, toArray, singleton } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Tab_Option, tab, Option, tabs } from "../../../fable_modules/Fulma.3.0.0/Components/Tabs.fs.js";
import { DOMAttr, HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";

export function asTimeStampString(date) {
    const arg = day(date) | 0;
    const arg_1 = month(date) | 0;
    const arg_2 = year(date) | 0;
    const arg_3 = hour(date) | 0;
    const arg_4 = minute(date) | 0;
    return toText(printf("%02i.%02i.%04i - %02i:%02i"))(arg)(arg_1)(arg_2)(arg_3)(arg_4);
}

export function actionHoverMenu(dispatch, token) {
    let children_2, children, children_8, children_6;
    const menuName = toText(printf("dropdown-%O"))(token.Id);
    const children_10 = [(children_2 = [(children = [icon("fas fa-ellipsis-v")], react.createElement("div", {
        "aria-haspopup": true,
        "aria-controls": menuName,
    }, ...children))], react.createElement("div", {
        className: "dropdown-trigger",
    }, ...children_2)), (children_8 = [(children_6 = [react.createElement("a", {
        className: "dropdown-item",
        onClick: (_arg) => {
            dispatch(new Msg(3, [token.Id]));
        },
    }, "API-Token löschen")], react.createElement("div", {
        className: "dropdown-content",
    }, ...children_6))], react.createElement("div", {
        className: "dropdown-menu",
        id: menuName,
        role: "menu",
    }, ...children_8))];
    return react.createElement("div", {
        className: "dropdown is-hoverable is-right",
    }, ...children_10);
}

export function tokenRow(dispatch, token) {
    let children_8, children, children_2, children_6;
    return singleton((children_8 = [(children = [asTimeStampString(token.Erstellt)], react.createElement("td", {}, ...children)), (children_2 = [defaultArg(map(asString, token.LetzteNutzung), "")], react.createElement("td", {}, ...children_2)), react.createElement("td", {}, "***"), (children_6 = [actionHoverMenu(dispatch, token)], react.createElement("td", {
        className: "pull-right",
    }, ...children_6))], react.createElement("tr", {}, ...children_8)));
}

export function filialenRow(selectedFilialeId, dispatch, filialen) {
    const selectedFilialeId_1 = defaultArg(selectedFilialeId, "00000000-0000-0000-0000-000000000000");
    return tabs(singleton(new Option(7, ["is-hidden-touch account-tabs main-menu with-width-constraint"])), [toArray(map_1((f) => tab(ofArray([new Tab_Option(1, ["submenu-item"]), new Tab_Option(0, [f.Id === selectedFilialeId_1])]), singleton(react.createElement("a", {
        onClick: (_arg) => {
            dispatch(new Msg(2, [f.Id]));
        },
    }, f.Name))), filialen))]);
}

export function filialenMobile(selectedFilialeId, dispatch, filialen) {
    let children_8, children_6;
    const selectedFilialeId_1 = defaultArg(selectedFilialeId, "00000000-0000-0000-0000-000000000000");
    const children_10 = [(children_8 = [(children_6 = [toArray(map_1((f) => {
        let children_2;
        const props_4 = [new HTMLAttr(65, ["wishlist-item " + ((f.Id === selectedFilialeId_1) ? "is-active" : "")]), new DOMAttr(40, [(_arg) => {
            dispatch(new Msg(2, [f.Id]));
        }])];
        const children_4 = [(children_2 = [react.createElement("a", {}, f.Name)], react.createElement("div", {
            className: "item-wrapper",
        }, ...children_2))];
        return react.createElement("li", keyValueList(props_4, 1), ...children_4);
    }, filialen))], react.createElement("ul", {
        className: "wishlists",
    }, ...children_6))], react.createElement("div", {
        className: "flat-card is-auto menu-card",
    }, ...children_8))];
    return react.createElement("div", {
        className: "is-hidden-desktop",
    }, ...children_10);
}

export function tokenCardBody(dispatch, model) {
    let children_14, children_10, children_8, children_12, children_18;
    const matchValue = model.Filialen;
    switch (matchValue.tag) {
        case 3:
            if (isEmpty(matchValue.fields[0])) {
                return "Keine Filiale mit Token vorhanden";
            }
            else {
                const matchValue_1 = model.SelectedFiliale;
                if (matchValue_1 != null) {
                    const id = matchValue_1;
                    const filiale = find((x_2) => (x_2.Id === id), matchValue.fields[0]);
                    const children_20 = [(children_14 = [(children_10 = [(children_8 = [react.createElement("th", {}, "Erstellt"), react.createElement("th", {}, "Letzte Nutzung"), react.createElement("th", {}, "Token"), react.createElement("th", {})], react.createElement("tr", {}, ...children_8))], react.createElement("thead", {}, ...children_10)), (children_12 = collect((token) => tokenRow(dispatch, token), filiale.Tokens), react.createElement("tbody", {}, ...children_12))], react.createElement("table", {
                        className: "table table-striped responsive-table",
                    }, ...children_14)), (children_18 = toList(delay(() => append(isEmpty(filiale.Tokens) ? singleton_1("Es existiert noch kein API-Token für diese Filiale. ") : empty(), delay(() => append(singleton_1(react.createElement("a", {
                        onClick: (_arg) => {
                            const matchValue_2 = model.SelectedFiliale;
                            if (matchValue_2 != null) {
                                dispatch(new Msg(6, [matchValue_2]));
                            }
                        },
                    }, "Neues API-Token erzeugen")), delay(() => singleton_1("."))))))), react.createElement("div", {
                        className: "center-text",
                    }, ...children_18))];
                    return react.createElement("div", {}, ...children_20);
                }
                else {
                    return "Keine Filiale ausgewählt";
                }
            }
        case 1:
            return spinner;
        case 2:
            return errorMsg(matchValue.fields[0]);
        default:
            return "Keine Filialen vorhanden";
    }
}

export function content(model, dispatch) {
    let children_6, children_4, children_2, props_2, children, s;
    const children_8 = [(children_6 = [(children_4 = [(children_2 = [(props_2 = [["style", {
        margin: "0.8rem",
    }]], (children = [(s = "Um anderen Anwendungen Zugriff auf Ihr BFS-Konto zu gestatten, können Sie hier API-Token erzeugen. Diese API-Token werden von der anderen Anwendung zur Authentifizierung genutzt.", s), react.createElement("br", {}), "Sobald Sie ein API-Token hier löschen, kann diese Anwendung nicht mehr auf Ihr BFS-Konto zugreifen."], react.createElement("p", keyValueList(props_2, 1), ...children))), tokenCardBody(dispatch, model)], react.createElement("div", {
        className: "card-body",
    }, ...children_2))], react.createElement("div", {
        className: "flat-card profile-info-card is-auto overflow-initial",
    }, ...children_4))], react.createElement("div", {
        className: "column is-12",
    }, ...children_6))];
    return react.createElement("div", {
        className: "columns",
    }, ...children_8);
}

export function view(model, dispatch, navigateTo) {
    return Array.from(delay(() => {
        let matchValue;
        return append((matchValue = model.Filialen, (matchValue.tag === 3) ? ((length(matchValue.fields[0]) > 1) ? append(singleton_1(filialenRow(model.SelectedFiliale, dispatch, matchValue.fields[0])), delay(() => singleton_1(filialenMobile(model.SelectedFiliale, dispatch, matchValue.fields[0])))) : (empty())) : (empty())), delay(() => singleton_1(content(model, dispatch))));
    }));
}

//# sourceMappingURL=View.fs.js.map
